module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/avatar-956dfae93e3ea959664862c28c4d1c74.svg";